export type FetchResult<T> = { data?: T; error?: string };

export function addContentId(contentId: string): string {
	return `contentId=${contentId}`;
}
export async function queryHelper<T>(requestToken: string, url: string): Promise<FetchResult<T>> {
	try {
		const res = await fetch(url, {
			method: 'GET',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
				RequestVerificationToken: requestToken
			}
		});
		if (res.ok) {
			const response = await res.json();
			if (response.success === true) {
				return { data: response.result };
			} else {
				const err = response.message;
				return { error: err };
			}
		} else {
			const err = await res.text();
			return { error: err };
		}
	} catch (e) {
		return { error: 'Error: Something went wrong with the query' };
	}
}

export async function mutateHelper<T, I>(model: I, requestToken: string, url: string): Promise<FetchResult<T>> {
	try {
		const res = await fetch(url, {
			method: 'POST',
			body: JSON.stringify(model),
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
				RequestVerificationToken: requestToken
			}
		});
		if (res.ok) {
			const response = await res.json();
			if (response.success === true) {
				return { data: response.result };
			} else {
				const err = response.message;
				return { error: err };
			}
		} else {
			const err = await res.text();
			return { error: err };
		}
	} catch (e) {
		return { error: `Error: ${e.message}` };
	}
}
